module.exports = __webpack_public_path__ + "img/Project_158-03-removebg-preview.515d85b8.png";